/**
 * This file contains PropTypes definitions that match the TypeScript definitions in models.js
 * It can be imported by React components that need to validate enterprise detail props
 */

// External packages
import PropTypes from 'prop-types';

/**
 * PropTypes shape for SignupURLReq
 * @see SignupURLReq in models.js
 */
export const SignupURLReqPropType = PropTypes.shape({
  path_param: PropTypes.string,
  target: PropTypes.string,
  requestType: PropTypes.string,
  payload: PropTypes.string
});

/**
 * PropTypes shape for SignupURLRes
 * @see SignupURLRes in models.js
 */
export const SignupURLResPropType = PropTypes.shape({
  response: PropTypes.string
});

/**
 * PropTypes shape for SignupURL
 * @see SignupURL in models.js
 */
export const SignupURLPropType = PropTypes.shape({
  name: PropTypes.string,
  url: PropTypes.string,
  projectID: PropTypes.string
});

/**
 * PropTypes shape for SignInDetail
 * @see SignInDetail in models.js
 */
export const SignInDetailPropType = PropTypes.shape({
  signinUrl: PropTypes.string,
  signinEnrollmentToken: PropTypes.string,
  qrCode: PropTypes.string,
  defaultStatus: PropTypes.string
});

/**
 * PropTypes shape for GoogleAuthenticationSettings
 * @see GoogleAuthenticationSettings in models.js
 */
export const GoogleAuthenticationSettingsPropType = PropTypes.shape({
  googleAuthenticationRequired: PropTypes.string
});

/**
 * PropTypes shape for the contact information
 * @see contactInfo in EnterpriseDetails in models.js
 */
export const ContactInfoPropType = PropTypes.shape({
  dataProtectionOfficerName: PropTypes.string,
  dataProtectionOfficerEmail: PropTypes.string,
  dataProtectionOfficerPhone: PropTypes.string,
  euRepresentativeName: PropTypes.string,
  euRepresentativeEmail: PropTypes.string,
  euRepresentativePhone: PropTypes.string,
  contactEmail: PropTypes.string
});

/**
 * PropTypes shape for EnterpriseDetails
 * @see EnterpriseDetails in models.js
 */
export const EnterpriseDetailsPropType = PropTypes.shape({
  name: PropTypes.string,
  enabledNotificationTypes: PropTypes.arrayOf(PropTypes.string),
  pubsubTopic: PropTypes.string,
  enterpriseDisplayName: PropTypes.string,
  signinDetails: PropTypes.arrayOf(SignInDetailPropType),
  googleAuthenticationSettings: GoogleAuthenticationSettingsPropType,
  enterpriseType: PropTypes.string,
  managedGoogleDomainType: PropTypes.string,
  contactInfo: ContactInfoPropType
});

/**
 * PropTypes for the full enterprise response
 * @see EnterpriseResponse in models.js
 */
export const EnterpriseResponsePropType = PropTypes.shape({
  enterpriseId: PropTypes.string,
  serviceAccount: PropTypes.string,
  hasToken: PropTypes.bool,
  accountType: PropTypes.string,
  enterpriseDetails: PropTypes.oneOfType([
    PropTypes.string,
    EnterpriseDetailsPropType
  ]),
  enterpriseDisplayName: PropTypes.string,
  enterpriseType: PropTypes.string
});

/**
 * PropTypes for the base API response
 * @see BaseResponse in models.js
 */
export const BaseResponsePropType = PropTypes.shape({
  response: PropTypes.string
});
